import { jsonDelete, jsonGet, jsonPost, jsonPut } from "../../api";

export const fetchBrandAwareness = async (brandId) =>
  await jsonGet(`/brands/${brandId}/awareness`);

export const fetchBrandAwarenessOverview = async (brandId) =>
  await jsonGet(`/brands/${brandId}/awareness/overview`);

export const fetchBrandAwarenessDetailByIndustry = async (brandId, industry) =>
  await jsonGet(`/brands/${brandId}/awareness/overview/${encodeURIComponent(industry)}`);

// export const measureBrandAwareness = async (brandId) =>
//   await jsonPost(`/brands/${brandId}/awareness`);
